import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "m-blockNotice__content" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { key: 2 }
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["m-blockNotice", {
        '-informational': _ctx.type === _ctx.NoticeType.Info,
        '-error': _ctx.type === _ctx.NoticeType.Error,
        '-success': _ctx.type === _ctx.NoticeType.Success,
        '-warning': _ctx.type === _ctx.NoticeType.Warning,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.title !== null && _ctx.isTitleTranslation)
        ? _withDirectives((_openBlock(), _createElementBlock("h2", _hoisted_2, null, 512)), [
            [_directive_translate, _ctx.title]
          ])
        : _createCommentVNode("", true),
      (_ctx.title !== null && !_ctx.isTitleTranslation)
        ? (_openBlock(), _createElementBlock("h2", {
            key: 1,
            innerHTML: _ctx.title
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      (_ctx.content !== null && _ctx.isContentTranslation)
        ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_4, null, 512)), [
            [_directive_translate, _ctx.content]
          ])
        : _createCommentVNode("", true),
      (_ctx.content !== null && !_ctx.isContentTranslation)
        ? (_openBlock(), _createElementBlock("p", {
            key: 3,
            innerHTML: _ctx.content
          }, null, 8, _hoisted_5))
        : _createCommentVNode("", true)
    ])
  ], 2))
}